import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import { Content, Row, Col } from "../../components/GridComponent/AdminLte.js";
import { acknowledgeCOC } from "../../store/actions/userActions";

/**
 * The `coc` custom-form slot: the two-step Code of Conduct body (SPEC 7.4 / 21.7).
 *
 *   payload = { step: 1|2, forms_count, form: { form_no, content } | null }
 *
 * The form shown is payload.form.content (the stored HTML the engine picked for the step; the
 * same bytes settings.coc_forms carried for the hand-coded modal). Both steps save through
 * acknowledgeCOC (POST /acknowledge_coc/, no body), exactly as before:
 *
 *   step 1  "I understand that this action is mandatory." checkbox gates the "I Agree" button;
 *           a successful save calls onDefer() — NOT onComplete — because the second step is due
 *           two days later and completing now would make the engine never ask again (21.3)
 *   step 2  an always-enabled "I Confirm"; a successful save calls onComplete()
 *
 * A failed save (the thunk alerted and resolved false) leaves the form as it is. One request at
 * a time: a second click while the save is in flight is ignored.
 */
class CocSlot extends Component {
  state = { isCocChecked: false };
  inFlight = false;

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  step = () => ((this.props.payload || {}).step === 2 ? 2 : 1);

  acknowledge = () => {
    if (this.inFlight) return;
    const step = this.step();
    if (step === 1 && !this.state.isCocChecked) return;
    this.inFlight = true;
    Promise.resolve(this.props.acknowledgeCOC()).then((ok) => {
      this.inFlight = false;
      if (!ok || !this.mounted) return;
      if (step === 2) {
        this.props.onComplete();
      } else {
        this.props.onDefer();
      }
    });
  };

  render() {
    const step = this.step();
    const form = (this.props.payload || {}).form;
    const content = form && form.content;

    return (
      <div className="coc-body">
        <Content col="12">
          <Row>
            <Col size="12">
              <div className="form-group survey-description">
                {content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col size="12">
              <br />
              <span>
                <div style={{ textAlign: "center" }}>
                  {step === 1 ? (
                    <>
                      <input
                        type="checkbox"
                        id="mandatoryCheckbox"
                        className="form-check-input"
                        checked={this.state.isCocChecked}
                        onChange={() => this.setState({ isCocChecked: !this.state.isCocChecked })}
                      />
                      <label htmlFor="mandatoryCheckbox" className="form-check-label">
                        I understand that this action is mandatory.
                      </label>
                      <br />
                    </>
                  ) : null}

                  <Button
                    type="button"
                    className="btn btn-primary-2"
                    disabled={step === 1 && !this.state.isCocChecked}
                    onClick={this.acknowledge}
                    style={{ marginTop: "20px" }}
                  >
                    <i className="fa is-green fa-location-arrow" />{" "}
                    {step === 1 ? "I Agree" : "I Confirm"}
                  </Button>
                </div>
              </span>
            </Col>
          </Row>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acknowledgeCOC: () => dispatch(acknowledgeCOC()),
  };
};

export default connect(null, mapDispatchToProps)(CocSlot);
